if (!customElements.get('mini-format-builder')) {
  customElements.define(
    'mini-format-builder',
    class MiniFormatBuilder extends HTMLElement {
      connectedCallback() {
        this.options = [...this.querySelectorAll('[data-mini-format-option]')];
        this.button = this.querySelector('[data-mini-format-submit]');
        this.count = this.querySelector('[data-mini-format-count]');
        this.total = this.querySelector('[data-mini-format-total]');
        this.message = this.querySelector('[data-mini-format-message]');

        this.options.forEach((option) => option.addEventListener('change', () => this.update()));
        this.button?.addEventListener('click', () => this.addSelection());
        this.update();
      }

      get selectedOptions() {
        return this.options.filter((option) => option.checked);
      }

      update() {
        const selectedCount = this.selectedOptions.length;
        const selectionLimitReached = selectedCount >= 3;

        this.options.forEach((option) => {
          option.disabled = !option.checked && selectionLimitReached;
          option.closest('[data-mini-format-card]')?.classList.toggle('is-selected', option.checked);
        });

        if (this.count) this.count.textContent = `${selectedCount} / 3`;
        if (this.total) {
          this.total.textContent = selectedCount === 2 ? '340 €' : selectedCount === 3 ? '480 €' : this.dataset.labelPerArtwork;
        }
        if (this.button) {
          this.button.disabled = selectedCount < 2;
          this.button.querySelector('span').textContent = selectedCount === 3 ? this.dataset.labelTrio : this.dataset.labelDuo;
        }
        if (this.message) this.message.textContent = selectedCount < 2 ? this.dataset.labelSelectMore : '';
      }

      async addSelection() {
        const selectedOptions = this.selectedOptions;
        if (selectedOptions.length < 2 || selectedOptions.length > 3) return;

        this.button.disabled = true;
        this.button.classList.add('loading');
        this.message.textContent = '';

        try {
          const response = await fetch(`${window.routes.cart_add_url}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              items: selectedOptions.map((option) => ({
                id: Number(option.value),
                quantity: 1,
              })),
            }),
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || this.dataset.labelError);
          window.location.assign(window.routes.cart_url);
        } catch (error) {
          this.message.textContent = error.message;
          this.button.disabled = false;
          this.button.classList.remove('loading');
        }
      }
    },
  );
}
